export default __webpack_public_path__ + "static/rovo-elevation-dark-d9a9baafe1acbd30f74b8b80d55b945d.png";